import useMortgage from "../../../../../../providers/mortgage/useMortgage";
import {boi} from "../../../../../../../assets/scripts/lender-calculators/boi";
import useXls, {useXlsNew} from "../useXls";

export function useBoiXlsNew() {

    const mortgage = useMortgage()
    const api = boi({mortgage})
    const getProcessedResults = (results) => {

        let items = !!results ? Object.keys(results).map(key => {
            return {
                key  : key,
                label: key,
                value: results[key].trim()
            }
        }) : []
        const doTest = (key, items) => {
            switch (key) {
                case 'NDI Surplus / Shortfall':
                    let v1 = parseFloat(items.find(it => it.key === 'NDI Surplus / Shortfall').value.replace(/[^\d.]/g, ''))
                    return v1  >= 0
                case '% Proven DRA':
                    let multiplier = parseFloat(items.find(it => it.key === 'Income Multiple').value.replace(/[^\d.]/g, ''))
                    let maxTarget = multiplier <= 3.5 ? 85 : 100
                    let provenDRA = parseFloat(items.find(it => it.key === '% Proven DRA').value.replace(/[^\d.]/g, ''))
                    return provenDRA >= maxTarget
                case 'DRA Shortfall':
                    let dra  = items.find(it => it.key === 'DRA Shortfall').value.replace(/[^\d.]/g, '')
                    return dra < 1000
                case 'Credit Policy Results':
                    return items.find(it => it.key === 'Credit Policy Results').value === "Meets affordability criteria"
                case 'CBoI Limits':
                    return items.find(it => it.key === 'CBoI Limits').value === "Within CBI macro prudential limits"
                default:
                    return null
            }
        }
        items.forEach(item => {
            let test = doTest(item.key, items)
            if (test !== null) {
                item.passed = test
            }
        })
        return items
    }
    return useXlsNew(api, getProcessedResults, mortgage)
}
export function useBoiXls() {

    const mortgage = useMortgage()
    const api = boi({mortgage})
    const getProcessedResults = (results) => {

        let items = !!results ? Object.keys(results).map(key => {
            return {
                key  : key,
                label: key,
                value: results[key].trim()
            }
        }) : []
        const doTest = (key, items) => {
            switch (key) {
                case 'NDI Surplus / Shortfall':
                    let v1 = parseFloat(items.find(it => it.key === 'NDI Surplus / Shortfall').value.replace(/[^\d.]/g, ''))
                    return v1  >= 0
                case '% Proven DRA':
                    return parseFloat(items.find(it => it.key === '% Proven DRA').value.replace(/[^\d.]/g, '')) >= 100
                case 'DRA Shortfall':
                    return items.find(it => it.key === 'DRA Shortfall').value === "€0"
                case 'Credit Policy Results':
                    return items.find(it => it.key === 'Credit Policy Results').value === "Meets affordability criteria"
                case 'CBoI Limits':
                    return items.find(it => it.key === 'CBoI Limits').value === "Within CBI macro prudential limits"
                default:
                    return null
            }
        }
        items.forEach(item => {
            let test = doTest(item.key, items)
            if (test !== null) {
                item.passed = test
            }
        })
        return items
    }
    return useXls(api, getProcessedResults, mortgage)
}